import React from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate} from "@azure/msal-react";
import {MDBCarousel, MDBCarouselItem} from 'mdb-react-ui-kit';
import {useLocation} from "react-router-dom";


export default function DesignView() {

    const job = useLocation().state

    function DisplayDesigns(props) {
        const status = job.designStatus;
        const vehicleImages = require.context("../../testing/testingImages/", true, /\.jpg$/);

        if (status === "NO DESIGNS") {
            return (
                <div className="list-section">
                    <h3> No designs created yet </h3>
                    <hr/>
                    <br/>
                    <p>Designs requested by {job.name} on {job.dates.designsRequested}.</p>

                    <br/>
                    <a className="btn btn-primary" href="/management/jobs/view1"> Job Information </a>
                </div>);
        }

        if (status === "DESIGNS UPLOADED") {
            return (
                <div className="list-section">
                    <h3> Created Designs </h3>
                    <hr/>
                    <br/>


                    <MDBCarousel showControls showIndicators interval={5000} keyboard className="carousel-medium">
                        <MDBCarouselItem
                            className='d-block car-img text-center'
                            itemId={1}
                            src={job.designImages.designOne}
                            alt='...'>
                            <h5>First design</h5>
                        </MDBCarouselItem>

                        <MDBCarouselItem
                            className=' d-block car-img '
                            itemId={2}
                            src={job.designImages.designTwo}
                            alt='...'>
                            <h5>Second design</h5>
                        </MDBCarouselItem>

                        <MDBCarouselItem
                            className=' d-block car-img '
                            itemId={3}
                            src={job.designImages.designThree}
                            alt='...'>
                            <h5>Third design</h5>
                        </MDBCarouselItem>

                    </MDBCarousel>

                    <br/>

                    <p> Uploaded by [employee.name] on {job.dates.designsUploaded}.</p>
                    <p> Waiting for {job.name} to choose thier favourite design. </p>
                </div>
            );
        }

        if (status === "DESIGN CHOSEN") {
            return (
                <div>
                    <div className="list-section">
                        <h3> Chosen Design </h3>
                        <hr/>
                        <br/>

                        <img className="car-img-alone" src={job.designImages.designThree} alt="..."/>

                        <br/>
                        <br/>
                        <p> Design chosen on {job.dates.designChosen}</p>
                        <p> Awaiting payment from {job.name}</p>
                    </div>

                    <div className="page-break"></div>

                </div>
            );
        }

        if (status === "COMPLETE") {
            return (
                <div>

                    <div className="list-section">
                        <h3> Log information </h3>
                        <hr/>
                        <br/>

                        <p> Designs were requested on {job.dates.designsRequested}.</p>
                        <p> Designs were uploaded by [employee name] on {job.dates.designsUploaded}</p>
                        <p> A final design was chosen by {job.name} on {job.dates.designChosen}</p>
                        <p> Payment was accepted from {job.name} on {job.dates.designsCompleted}</p>
                    </div>

                    <div className="page-break"></div>

                    <div className="list-section">
                        <h3> Chosen Design </h3>
                        <hr/>
                        <br/>

                        <img className="car-img-alone" src={job.designImages.chosenDesign} alt="..."/>

                        <br/>
                    </div>

                    <div className="page-break"></div>

                    <div className="list-section">
                        <h3> All Designs </h3>
                        <hr/>
                        <br/>

                        <MDBCarousel showControls showIndicators interval={5000} keyboard className="carousel-medium">
                            <MDBCarouselItem
                                className='d-block car-img text-center'
                                itemId={1}
                                src={job.designImages.designOne}
                                alt='...'>
                                <h5>First Design</h5>
                            </MDBCarouselItem>

                            <MDBCarouselItem
                                className=' d-block car-img '
                                itemId={2}
                                src={job.designImages.designTwo}
                                alt='...'>
                                <h5>Second design</h5>
                            </MDBCarouselItem>

                            <MDBCarouselItem
                                className=' d-block car-img '
                                itemId={3}
                                src={job.designImages.designThree}
                                alt='...'>
                                <h5>Third design</h5>
                            </MDBCarouselItem>

                        </MDBCarousel>
                    </div>

                    <div className="page-break"></div>

                </div>
            );
        }

    }

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>Designs for {job.name} </h1>
                    <h5 className="text-secondary"> Job #{job.id}</h5>

                </div>
                <hr/>

                <div className="page-break"></div>

                <DisplayDesigns/>


                <div className="page-break"></div>

            </AuthenticatedTemplate>
        </div>
    );
}
